import React from 'react'
import Layout from '../../../shared/components/organisms/layout/layout'
import useMediaQuery from '../../../utils/useMediaQuery'
import AppSEO from '../../atoms/app-seo/app-seo'

import './page-layout.scss'
import { siteUrl } from '@/shared/utils/siteUrl'

interface IPropsPageLayout {
  children: React.ReactNode
}
const PageLayout = ({ children }: IPropsPageLayout) => {
  let isMobile = useMediaQuery()
  return (
    <Layout
      mobile={isMobile}
      redirectRegister={() => {
        return siteUrl + '/registro/?url=' + siteUrl + location.pathname
      }}
    >
      <AppSEO />
      {children}
    </Layout>
  )
}

export default PageLayout
